








































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import FaqBox from '@/components/FaqBox.vue';
import ScrollArea from '@/pages/P0918/ScrollArea.vue';

import '../../public/static/assets/css/lp_odekake-pack.css';

@Component({
  components: { FaqBox, ScrollArea }
})
export default class P0925 extends Vue {
  isToggles: Boolean[] = [false, false, false, false, false];
  params = new URLSearchParams(window.location.search);
  hasJuren = this.params.has('juren');

  //パラメータjurenが存在する場合は、最初からTabで充レンを選択した状態にする
  tabStatus: string = this.hasJuren ? 'juren' : 'ikasa';

  toggleBox(index: any) {
    if (this.isToggles[index]) {
      this.$set(this.isToggles, index, false);
    } else {
      this.$set(this.isToggles, index, true);
    }
  }
}
